import { useNicheOverviewSection } from './niche-overview-section.model'
import type { INichesOverviewSection } from './niches-overview-section.types'
import { NichesOverviewSectionView } from './niches-overview-section.view'

export function NichesOverviewSection({
  link,
  territoryId,
  setIsNichesEmpty,
  pageName,
  territoryTitle,
  providers,
  uploadDate,
  isTrendingTag,
  effectiveTerritoryId,
  feature,
}: INichesOverviewSection) {
  const nichesOverviewSectionModel = useNicheOverviewSection({
    territoryId,
    setIsNichesEmpty,
    pageName,
    territoryTitle,
    providers,
    uploadDate,
    isTrendingTag,
    effectiveTerritoryId,
    feature,
  })
  return <NichesOverviewSectionView isTrendingTag={isTrendingTag} link={link} {...nichesOverviewSectionModel} />
}
